// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__QN_JG","label":"styles_label__TXOGV","caption":"styles_caption__iMbhd","description":"styles_description__ti32A","content":"styles_content__c2pnN"};